export function getFormattedPhoneNumber(phoneNumber: string | undefined): string {
    if (!phoneNumber) return "";

    const phonePattern = /^(\d{3}[-.]?\d{3}[-.]?\d{4}|\d{7})(?:\s*(?:ext|extension|x)[.:]?\s*\d+)?$/i;

    if (!phonePattern.test(phoneNumber)) {
        return phoneNumber;
    }

    const [mainNumber, extension] = phoneNumber.split(/\s*(?:ext|extension|x)[.:]?\s*/i);

    if (mainNumber?.length === 7) {
        return mainNumber.slice(0, 3) + "-" + mainNumber.slice(3) + (extension ? ` ext. ${extension}` : "");
    }

    const cleaned = mainNumber.replace(/\D/g, "");
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = match[1] ? "+1 " : "";
        return (
            [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("") + (extension ? ` ext. ${extension}` : "")
        );
    }

    return phoneNumber;
}
